import { render, staticRenderFns } from "./ImporterFooter.vue?vue&type=template&id=ff8032e4&scoped=true&"
import script from "./ImporterFooter.vue?vue&type=script&lang=ts&"
export * from "./ImporterFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ImporterFooter.vue?vue&type=style&index=0&id=ff8032e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8032e4",
  null
  
)

export default component.exports